<template>
  <div
    class="single-message"
    :class="{ 'single-message--own' : isOwnMessage }"
  >
    <div class="single-message__meta">
      <div
        v-if="!isOwnMessage && !grouped"
        class="single-message__author"
      >
        <AppAvatar
          :user="user"
          size="24"
        />
        {{ message.firstName }} {{ message.lastName }}
      </div>
    </div>
    <v-tooltip
      :right="!isOwnMessage"
      :left="isOwnMessage"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="single-message__body"
          v-bind="attrs"
          v-on="on"
        >
          <div
            v-if="message.messageType === 'file'"
            class="single-message__file-container"
          >
            <div class="single-message__file">
              <AppFile :file="message.file" />
            </div>
            <a
              :href="message.file.url"
              target="_blank"
              class="single-message__download"
            >
              <span>Pobierz</span>
              <v-icon
                color="white"
                small
              >
                mdi-download
              </v-icon>
            </a>
          </div>
          <div
            v-else
            class="single-message__text"
          >
            <span v-html="parsedMessageText" />
          </div>
        </div>
      </template>
      <div class="single-message__date">
        {{ message.createdAt | dateWithTime }}
      </div>
    </v-tooltip>
  </div>
</template>

<script>
import AppAvatar from '@/components/UI/AppAvatar.vue';
import AppFile from '@/components/UI/AppFile.vue';

export default {
  components: {
    AppAvatar,
    AppFile,
  },

  props: {
    message: {
      type: Object,
      required: true,
    },
    grouped: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    user() {
      return {
        firstName: this.message.firstName,
        lastName: this.message.lastName,
      };
    },
    parsedMessageText() {
      const urlExpression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      const regex = new RegExp(urlExpression);
      const { text } = this.message;

      const dividedMessage = text.split(regex);
      const hyperlinks = text.match(regex)?.map((link) => {
        const parsedLink = link.indexOf('http') === 0 ? link : `//${link}`;
        return {
          key: link,
          tag: `<a href="${parsedLink}" target="_blank" class="single-message__url">${link}</a>`,
        };
      });

      const parsedMessage = dividedMessage.map((part) => {
        const parsedLink = hyperlinks?.find((link) => link.key === part)?.tag;
        return parsedLink || part;
      }).join('');

      return this.$sanitize(parsedMessage, {
        allowedAttributes: {
          a: ['href', 'class', 'target'],
        },
      });
    },
    isOwnMessage() {
      return this.message.userId === this.$store.state.auth.user.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.single-message {
  margin-right: 35%;
  margin-bottom: 8px;

  &__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__author {
    margin-bottom: 6px;
    margin-top: 8px;
  }

  &__date {
    font-size: 10px;
    letter-spacing: 0.5px;
  }

  &__body {
    background: $primary;
    color: white;
    border-radius: 8px;
    display: inline-block;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
    overflow: hidden;
    max-width: 100%;
  }

  &__text {
    white-space: pre-wrap;
    padding: 16px;
  }

  &__file-container {
    min-width: 220px;
  }

  &__file {
    padding: 8px 16px;
  }

  &__download {
    padding: 16px;
    background: $primary;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &--own {
    margin-right: unset;
    margin-left: 35%;
    text-align: right;

    .single-message__meta {
      display: block;
    }
    .single-message__body {
      background: $bg-light;
      color: $darken;
    }
  }
}
</style>
<style lang="scss">
.single-message:not(.single-message--own) .single-message__url {
  color: white !important;
  font-weight:500;
}
</style>
